export const ButtonColors = {
    buttonError: '#C70000',
    buttonErrorHover: '#c77777'
}
export const tabloHeight = (props) => window.innerHeight - (props ?? 70) + "px !important";

export var globalVal= {isLoggedOut:false};